<template>
  <a-empty>
    <slot />
  </a-empty>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { app } from '@/libs/app';
import { Empty } from 'ant-design-vue';
import './styles.scss';

app.use(Empty);

export default defineComponent({
  name: 'Empty',
  props: {
    dynamicAttrs: {},
  },
});
</script>
